import buildRoute from './buildRoute'

export const getUserRegistration = async (
    manufacturer: string,
    active: boolean
) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'registrationUsers',
            data: { manufacturer, active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const userRegistrationDeactivation = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'userRegistrationActivation',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface GetDealerProps {
    active: boolean
    page?: number
    limit?: number
    filter?: any
}

export const getUsersRegistrationWithLimiter = async ({
    active,
    page = 1,
    limit = 50,
    filter,
}: GetDealerProps) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'user-Registration-With-Limiter',
            data: { active, page, limit, filter },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const sendWelcomeEmails = async (userIds: string[]) => {
    try {
        console.log('userIds being sent:', userIds)
        console.log('userIds type:', Array.isArray(userIds))

        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'post-welcome-email-route',
            data: { userIds },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        console.error('Error response:', err.response?.data)
        throw err
    }
}
const userRegistrationRoutes = {
    getUserRegistration,
    userRegistrationDeactivation,
    getUsersRegistrationWithLimiter,
    sendWelcomeEmails,
}

export default userRegistrationRoutes
